import { Form, Input, Grid, Select, Field } from "@alifd/next";
import { BefGlobalContext, BefRpcContext } from "@beflam/bef-core";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";

const AssignUser = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, data, depId, ...otherProps } = props;
    const [dataSource, setDataSource] = useState({});
    const [ops, setOps] = useState<any>([]);
    const [users, setUsers] = useState<any>();
    const befRpc = useContext(BefRpcContext);
    const sGlobal = useContext(BefGlobalContext);
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const Option = Select.Option;
    const fieldRef = useRef(new Field(contextComp));

    useEffect(() => {
        if (depId) {
            getTypes();
        }
        fieldRef.current.reset();
        //  fieldRef.current.setValue('DepType', '');
        if (data !== undefined && data !== null) {
            //  setUsers(data.join(","));
            fieldRef.current.setValue('UserId', data.UserId);
            fieldRef.current.setValue('DepType', data.DepType);
        }

    }, []);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);
    const getTypes = async () => {

        let typeRes = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "TypeList", { AppId: sGlobal.currentAppId, Id: depId });
        setOps(typeRes);
    }
    return (<>
        <Form field={fieldRef.current} className="bef-custom-dep">
            <Grid.Row gutter="12">
                <Grid.Col>
                    <Form.Item label="用户编号" name="UserId" className="custom-form-control">
                        <Input disabled />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="职级" name="DepType" className="custom-form-control">
                        <Select
                            style={{ width: '100%' }}
                            hasClear>
                            {ops.map((op: any) => {
                                return <Option key={op.Id} value={op.Id}>{op.Name}</Option>
                            })}
                        </Select>
                    </Form.Item>
                </Grid.Col>
            </Grid.Row></Form>
    </>


    );
});
export default AssignUser;